// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.request_phone__mlxS\\+ {
  padding: 0 16px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.request_phone-inner__yvJDD {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  /* height: calc(100vh - 300px); */
  gap: 40px;
}
label {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  margin-bottom: 6px;
  margin-top: 16px;
}
label span {
  color: #fff;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}
.request_input-box__jLNo5 {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.request_input-box__jLNo5 input {
  width: 100%;
  align-items: center;
  height: 48px;
  padding: 16px 12px;
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  border-radius: 8px;
  border: 1px solid #f0f0f0;
}
.request_input-box__jLNo5 input::placeholder {
  color: #fff;
  text-align: right;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 171.429% */
}
.request_input-box__jLNo5 input:focus {
  border: 1px solid #fff;
}
.request_error__ckxaC {
  color: #ff9d9d;
  text-align: right;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 166.667% */
  margin-top: 6px;
  width: 100%;
}
.request_submit__6d-iw {
}
.request_deactive__whh7e {
  background: #3c112a;
}
.request_deactive__whh7e span {
  color: #fff;
}
.request_submit__6d-iw span {
  font-size: 16px;
}
.request_frame__TzDRK {
  width: 340px;
  border-radius: 12px;
}
.request_title__BPCoC {
  color: #fff;
  text-align: right;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
}
.request_down-box__ruT6h {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.request_down-box-inner__azRLw {
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
}

.request_banirule__RRIg4 {
  color: #fff;
  text-align: right;
  font-size: 12px;
  font-style: normal;
  font-weight: 325;
  line-height: 20px;
}
.request_banirule__RRIg4 span {
  color: #ffff;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
}
.request_top-box__QlgXP {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
}
@media screen and (min-width: 1200px) {
  .request_phone-inner__yvJDD {
    min-height: 300px;
    max-height: 400px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/login/request.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,iCAAiC;EACjC,SAAS;AACX;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAGlB,oCAAoC;EACpC,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;AACA;EACE,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,eAAe;EACf,WAAW;AACb;AACA;AACA;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE;IACE,iBAAiB;IACjB,iBAAiB;EACnB;AACF","sourcesContent":[".phone {\n  padding: 0 16px;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.phone-inner {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  /* height: calc(100vh - 300px); */\n  gap: 40px;\n}\nlabel {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  width: 100%;\n  margin-bottom: 6px;\n  margin-top: 16px;\n}\nlabel span {\n  color: #fff;\n  text-align: center;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n}\n.input-box {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.input-box input {\n  width: 100%;\n  align-items: center;\n  height: 48px;\n  padding: 16px 12px;\n  border-radius: 8px;\n  border: 1px solid #f0f0f0;\n  background: rgba(255, 255, 255, 0.1);\n  color: #fff;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n  border-radius: 8px;\n  border: 1px solid #f0f0f0;\n}\n.input-box input::placeholder {\n  color: #fff;\n  text-align: right;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px; /* 171.429% */\n}\n.input-box input:focus {\n  border: 1px solid #fff;\n}\n.error {\n  color: #ff9d9d;\n  text-align: right;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px; /* 166.667% */\n  margin-top: 6px;\n  width: 100%;\n}\n.submit {\n}\n.deactive {\n  background: #3c112a;\n}\n.deactive span {\n  color: #fff;\n}\n.submit span {\n  font-size: 16px;\n}\n.frame {\n  width: 340px;\n  border-radius: 12px;\n}\n.title {\n  color: #fff;\n  text-align: right;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n}\n.down-box {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n}\n.down-box-inner {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  width: 100%;\n}\n\n.banirule {\n  color: #fff;\n  text-align: right;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 325;\n  line-height: 20px;\n}\n.banirule span {\n  color: #ffff;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n}\n.top-box {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n}\n@media screen and (min-width: 1200px) {\n  .phone-inner {\n    min-height: 300px;\n    max-height: 400px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"phone": `request_phone__mlxS+`,
	"phone-inner": `request_phone-inner__yvJDD`,
	"input-box": `request_input-box__jLNo5`,
	"error": `request_error__ckxaC`,
	"submit": `request_submit__6d-iw`,
	"deactive": `request_deactive__whh7e`,
	"frame": `request_frame__TzDRK`,
	"title": `request_title__BPCoC`,
	"down-box": `request_down-box__ruT6h`,
	"down-box-inner": `request_down-box-inner__azRLw`,
	"banirule": `request_banirule__RRIg4`,
	"top-box": `request_top-box__QlgXP`
};
export default ___CSS_LOADER_EXPORT___;
